<template>
  <div>
    <el-upload
      :show-file-list="false"
      :on-success="(file) => handler().success(file)"
      :before-upload="(file) => init().beforeUpload(file)"
      :on-progress="(event, file, fileList) => handler().uploadProcess(event, file, fileList)"
      :action="uploadDomain"
      :data="{ token: qiniuToken }"
      drag
      class="upload-video">
      <video
        v-if="value[prop.key] && loading == false"
        :src="value[prop.url]"
        controls="controls"
        class="avatar"
        style="height:100%;width: 100%;">
        您的浏览器不支持视频播放
      </video>
      <span v-else-if="!value[prop.key] && loading == false">
        <i class="el-icon-upload"/>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </span>
      <el-progress v-if="loading == true" :percentage="uploadPercent" type="circle" style="margin-top:30px;"/>
      <div slot="tip" class="el-upload__tip">请保证视频格式正确，且不超过100M</div>
    </el-upload>
  </div>
</template>

<script>
import { imgDomain, uploadDomain } from '../../configs/env'
import { getQiniuToken } from '../../api/login';

export default{
  props: {
    label: {
      type: String,
      default: '视频',
    },
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
    prop: {
      type: Object,
      default: () => {
        return {
          key: 'video',
          url: 'video_url',
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      uploadPercent: 0, // 上传进度条
      qiniuToken: '',
      imgDomain,
      uploadDomain,
    }
  },
  methods: {
    init() {
      return {
        // 上传前置操作
        beforeUpload: async(file) => {
          // 视频上传: 验证视频格式和视频大小
          if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/m3u8'].indexOf(file.type) === -1) {
            this.$message.error('请上传正确的视频格式')
            this.qiniuToken = ''
            return false
          }
          if (this.qiniuToken) {
            return true
          }
          try {
            // 获取七牛云token
            const res = await getQiniuToken();
            this.qiniuToken = res.data.token
            return res.data.token
          } catch (err) {
            this.$message('请求出错')
            return false
          }
        },
      }
    },
    handler() {
      return {
        // 视频上传: 上传进度显示
        uploadProcess: (event, file, fileList) => {
          console.log(file)
          if (['mp4', 'ogg', 'flv', 'avi', 'wmv', 'rmvb', 'm3u8'].indexOf(file.name.split('.').pop().toLowerCase()) === -1) {
            this.loading = false
            return false
          }
          this.loading = true
          this.uploadPercent = Number(file.percentage.toFixed(0))
        },
        // 视频上传: 上传成功
        success: (file) => {
          console.log(file)
          this.loading = false
          this.$set(this.value, this.prop.url, this.imgDomain + file.key)
          this.$set(this.value, this.prop.key, file.key)
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-upload--picture-card{ width: 78px; height: 78px;line-height: 78px; }
.el-upload-list--picture-card{
  .el-upload-list__item{ max-height:78px; width: 78px; }
  .el-upload-list__item-thumbnail{ width:78px; height: auto;}
}
.el-upload-dragger{height:150px;width:200px;}
</style>



// WEBPACK FOOTER //
// src/components/form/uploadVideo.vue